menu:
  labels:
    label:
      show: 显示
      adjust_sizes: 调整大小...
      recommended_size: 推荐 (450x600)
      full_height: 全高
      half_height: 半高
      full_screen: 全屏
      align_to: 对齐到...
      center: 居中
      top_left: 左上
      top_right: 右上
      bottom_left: 左下
      bottom_right: 右下
      settings: 设置...
      about: 关于...
      open_inlay: 打开快速操作...
      open_widgets: 打开小部件...
      open_caption: 打开字幕...
      close_caption: 关闭字幕浮窗...
      caption_overlay: 字幕浮窗
      follow_window: 跟随窗口
      reset_position: 重置位置
      devtools: 开发者工具
      troubleshoot_beatsync: 排查「同步音律」问题...
      quit: 退出
